var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21573 4.40316C5.95206 4.40316 5.71092 4.5518 5.59245 4.78735L3.82954 8.29239H7.83735L9.76981 4.40316H6.21573ZM11.3279 4.40316L9.39545 8.29239H14.4113L12.5966 4.40316H11.3279ZM14.1364 4.40316L15.951 8.29239H20.1827L18.4653 4.79343C18.3481 4.55454 18.1051 4.40316 17.839 4.40316H14.1364ZM19.823 9.68774H12.6819V18.3506L19.823 9.68774ZM11.2866 18.3455V9.68774H4.17379L11.2866 18.3455ZM4.34589 4.16037C4.70131 3.45373 5.42473 3.00781 6.21573 3.00781H17.839C18.6374 3.00781 19.3662 3.46196 19.7179 4.17862L21.9286 8.68266C22.0493 8.92861 22.0149 9.22244 21.8407 9.43384L12.5226 20.7375C12.3899 20.8985 12.1922 20.9916 11.9837 20.9914C11.7751 20.9912 11.5776 20.8978 11.4452 20.7366L2.1586 9.43295C1.98339 9.21968 1.95038 8.92316 2.0744 8.67658L4.34589 4.16037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.527495c3d72d6ccd5d87c6575d4b6d25.svg";
export { ForwardRef as ReactComponent };